module.exports = __webpack_public_path__ + "static/media/coursio-logo.4072ed2e.svg";